export enum FileExtensionEnum{
    HEIC="heic",
    HEICMimetype="image/heic"
}